var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "divBox" }, [
    _c(
      "div",
      { staticClass: "v-height-flag" },
      [
        _c("el-card", [
          _c("div", { staticClass: "v-height-flag" }, [
            _c(
              "div",
              { directives: [{ name: "height", rawName: "v-height" }] },
              [_c("uploadPicture", { attrs: { btnShow: false } })],
              1
            ),
          ]),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }